import React, { useState, useRef, useEffect } from 'react';

export default function SignaturePad({ value, onChange, drawLabel = '✍️ Draw Signature', typeLabel = '⌨️ Type Name', typePlaceholder = 'Type your full name', onSave, onUsePreset, presetValue = '', hideTabs = false }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [mode, setMode] = useState(value && value.startsWith('typed:') ? 'type' : 'draw');
  const [showPreset, setShowPreset] = useState(false);
  const [typedName, setTypedName] = useState(value && value.startsWith('typed:') ? value.slice(6) : '');

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth * dpr;
    canvas.height = canvas.offsetHeight * dpr;
    ctx.scale(dpr, dpr);
    ctx.strokeStyle = '#1a2744';
    ctx.lineWidth = 2.5;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    if (value && value.startsWith('drawn:')) {
      const img = new Image();
      img.onload = () => ctx.drawImage(img, 0, 0, canvas.offsetWidth, canvas.offsetHeight);
      img.src = value.slice(6);
    }
  }, [mode, showPreset, value]); // eslint-disable-line react-hooks/exhaustive-deps

  const getPos = (e, canvas) => {
    const rect = canvas.getBoundingClientRect();
    const client = e.touches ? e.touches[0] : e;
    return { x: client.clientX - rect.left, y: client.clientY - rect.top };
  };

  const startDraw = (e) => {
    drawing.current = true;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const pos = getPos(e, canvas);
    ctx.beginPath();
    ctx.moveTo(pos.x, pos.y);
  };

  const draw = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const pos = getPos(e, canvas);
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();
  };

  const endDraw = () => {
    if (!drawing.current) return;
    drawing.current = false;
    const canvas = canvasRef.current;
    onChange('drawn:' + canvas.toDataURL());
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    onChange('');
  };

  return (
    <div>
      {!hideTabs && (
        <div className="sig-tabs">
          <button className={`sig-tab ${mode === 'draw' && !showPreset ? 'active' : ''}`} onClick={() => { setMode('draw'); setShowPreset(false); }}>{drawLabel}</button>
          <button className={`sig-tab ${mode === 'type' && !showPreset ? 'active' : ''}`} onClick={() => { setMode('type'); setShowPreset(false); }}>{typeLabel}</button>
          {onUsePreset && <button className={`sig-tab sig-tab-preset ${showPreset ? 'active' : ''}`} onClick={() => { setShowPreset(true); onUsePreset(); }}>⭐ Use Preset</button>}
        </div>
      )}
      {showPreset ? (
        <div className="sig-canvas-wrap" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80px', padding: '12px' }}>
          {presetValue.startsWith('drawn:')
            ? <img src={presetValue.slice(6)} alt="preset signature" style={{ maxHeight: '120px', maxWidth: '100%' }} />
            : <span className="sig-type-input">{presetValue.startsWith('typed:') ? presetValue.slice(6) : presetValue}</span>
          }
        </div>
      ) : mode === 'draw' ? (
        <div className="sig-canvas-wrap">
          <canvas
            ref={canvasRef}
            className="sig-canvas"
            onMouseDown={startDraw} onMouseMove={draw} onMouseUp={endDraw} onMouseLeave={endDraw}
            onTouchStart={startDraw} onTouchMove={draw} onTouchEnd={endDraw}
          />
          <button className="sig-clear" onClick={clearCanvas}>Clear</button>
        </div>
      ) : (
        <div>
          <input
            className="text-input sig-type-input"
            placeholder={typePlaceholder}
            value={typedName}
            onChange={e => { setTypedName(e.target.value); onChange('typed:' + e.target.value); }}
          />
          <p className="helper-text">Your typed name serves as your electronic signature</p>
        </div>
      )}
      {onSave && (
        <div style={{ textAlign: 'right', marginTop: '10px' }}>
          <button className="sig-save-btn" onClick={onSave}>Save</button>
        </div>
      )}
    </div>
  );
}
